import { useNotification } from '@btime/react-messager'

import { SETTINGS } from '../../_services/services'
import { getJsonQueryParam, getQueryParam } from '../../../../packages/kiti/utils/helpers/url'
import { getWorkspace } from '../../../../utils/session/sessionStorage'
import { useCheckinHandlerResult, useCheckinQueryString, useCheckinService } from '../ServiceContext'
import { useOnError } from '../_requests/_helpers/error'
import { useOnSuccess } from '../_requests/_helpers/success'
import { useSaveIntegrations } from '../_requests/saveIntegrations'

export const useExchanger = () => {
  const [_handlerResult] = useCheckinHandlerResult()
  const { integrationId } = getJsonQueryParam('state') || {}

  const notify = useNotification()
  const workspace = getWorkspace()

  const service = useCheckinService()

  const queryString = useCheckinQueryString()

  const [saveSessionIntegration] = useSaveIntegrations(integrationId)

  const handleSuccess = useOnSuccess(notify)
  const handleError = useOnError(notify)

  return () => {
    return [
      _handlerResult,
      saveSessionIntegration({
        queryString,
        clientId: SETTINGS[service]?.CLIENT_ID,
        redirectUri: `${SETTINGS[service]?.REDIRECT_URI}/${workspace}`,
        service
      })
        .then(handleSuccess)
        .catch(handleError)
    ]
  }
}
